import React from 'react';
import { ErrorPage } from '@is24at/react-ui-core';
import { SUPPORT_EMAIL } from '@is24at/react-constants';
import MainLayout from 'layouts/MainLayout';

const AppError = () => (
  <MainLayout>
    <ErrorPage
      headline="Es ist ein unerwarteter Fehler aufgetreten."
      subheadline="Bitte versuchen Sie es später erneut oder kontaktieren Sie unseren Support"
      supportEmailAddress={SUPPORT_EMAIL}
    />
  </MainLayout>
);

export default AppError;
